<button class="chat-fab" type="button" (click)="toggle()">
  <img
    class="chat-fab__logo"
    src="/images/selecthor_chatbot.png"
    alt="Selecthor customer service"
  />
</button>

@if (chat.isOpen()) {
  <section class="chat-panel">
    <header class="chat-header">
      <div class="chat-header__titles">
        <strong>{{ 'chatbot.panel.title' | transloco }}</strong>
        <span class="chat-header__disclosure">{{ 'chatbot.panel.aiDisclosure' | transloco }}</span>
      </div>
      <button type="button" (click)="chat.setOpen(false)">✕</button>
    </header>

    <div #messagesContainer class="chat-body">
      @for (msg of chat.messages(); track msg.createdAt + msg.text) {
        <div class="msg" [class.user]="msg.role === 'user'" [class.bot]="msg.role === 'bot'">
          {{ msg.text }}
        </div>
      }
      @if (chat.isLoading()) {
        <div class="msg bot">{{ 'chatbot.typing' | transloco }}</div>
      }
    </div>

    <footer class="chat-footer">
      <input
        type="text"
        [ngModel]="chat.draft()"
        (ngModelChange)="chat.setDraft($event)"
        (keydown.enter)="onSend()"
        placeholder="{{ 'chatbot.type.your.message' | transloco }}"
      />
      <button type="button" (click)="onSend()" [disabled]="chat.isLoading()">
        {{ 'chatbot.send.message' | transloco }}
      </button>
    </footer>
  </section>
}
